import types from '../types';

const chatModerators = (
  state = { loading: true, failure: false, data: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_CHAT_MODERATORS_START:
      return { ...state, loading: true, failure: false };

    case types.GET_CHAT_MODERATORS_SUCCESS:
      return { data: payload, loading: false, failure: false };

    case types.POST_CHAT_MODERATOR_SUCCESS:
      return {
        ...state,
        data: { ...state.data, users: [...state.data.users, payload] },
        loading: false,
        failure: false,
      };

    case types.PUT_CHAT_MODERATOR_ROLE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          users: state.data.users.filter(user => user.user_id !== payload),
        },
        loading: false,
        failure: false,
      };

    case types.GET_CHAT_MODERATORS_FAILURE:
      return { ...state, loading: false, failure: true };

    default:
      return state;
  }
};

export default chatModerators;
